import FKApi from "./api";

export class Services {
    public readonly api: FKApi = new FKApi();
}
